// Import the `Accordion` class from the `./accordion` module
import { Accordion } from './js/accordion';

// Define an `AccordionGroup` class
export class AccordionGroup {
	// Constructor function that takes a DOM element `el` as a parameter
	constructor(el, autoCloseSiblings = false) {
		// Check if the `el` parameter is present
		if (el) {
			// Store the `el` parameter as an instance variable
			this.el = el;

			// Query all the `.wp-block-embark-accordion` elements within `el`
			this.accordionEls = [...this.el.querySelectorAll('.wp-block-embark-accordion')];

			// If any `.wp-block-embark-accordion` elements are found
			if (this.accordionEls.length) {
				// Create a new `Accordion` object for each `.wp-block-embark-accordion` element
				this.accordions = this.accordionEls.map((accordionEl) => {
					// Query the control and content elements within the `.wp-block-embark-accordion` element
					const control = accordionEl.querySelector('.wp-block-embark-accordion__control');
					const content = accordionEl.querySelector('.wp-block-embark-accordion__content');

					// Create a new `Accordion` object with the `control`, `content`, and `group` properties
					return new Accordion({
						control,
						content,
						group: this,
						autoCloseSiblings,
					});
				});
			}
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	// Query all the `.wp-block-embark-accordions` elements on the page
	const accordions = [...document.querySelectorAll('.wp-block-embark-accordions')];

	// If any `.wp-block-embark-accordions` elements are found
	if (accordions.length) {
	// Create a new `AccordionGroup` object for each `.wp-block-embark-accordions` element
		embark.components.accordions = accordions.map((el) => new AccordionGroup(el));
	}
});
